import React from 'react';
import style from './index.module.css';

import { EditorImageUploader, EditorEmojiPicker } from '@debank/content-editor';
import { initEditorDependency } from '@/views/CreateStream/initEditorDependency';

initEditorDependency();
export const MessageInputToolbar = ({
  onEmojiSelect,
  onBeforeUpload,
}: {
  onEmojiSelect: (emoji: string) => void;
  onBeforeUpload: (file: any) => Promise<void>;
}) => {
  return (
    <div className={style.container}>
      <EditorImageUploader className={style.toolbarOperateButton} beforeUpload={onBeforeUpload} />
      <EditorEmojiPicker
        onEmojiSelect={onEmojiSelect}
        viewportOverlay={''}
        positions={['top', 'right']}
      />
    </div>
  );
};
